import axios from 'axios'
import jwtDecode from 'jwt-decode'
import useAuth from './useAuth'
import { SERVER_URL_TOKEN } from '../services/services'

const queryString = require('query-string')

const useRefreshToken = () => {
  const { setAuth } = useAuth()

  const refresh = async () => {
    let refreshTokenLS = null

    try {
      const raw = localStorage.getItem('user')
      refreshTokenLS = raw ? JSON.parse(raw) : null
    } catch {
      localStorage.removeItem('user')
      setAuth({})
      throw new Error('Invalid stored session')
    }

    if (!refreshTokenLS?.r) {
      localStorage.removeItem('user')
      setAuth({})
      throw new Error('Missing refresh token')
    }

    try {
      const body = queryString['stringify']({
        client_id: 'sekaans-spa-client',
        client_secret: 'secret',
        refresh_token: refreshTokenLS.r,
        grant_type: 'refresh_token'
      })

      const res = await axios.post(SERVER_URL_TOKEN, body, {
        withCredentials: true
      })
      const accessToken = res.data.access_token
      const refreshToken = res.data.refresh_token

      if (!accessToken) {
        throw new Error('No access token in refresh response')
      }

      const readToken = jwtDecode(accessToken)
      const role = Array.isArray(readToken.role) ? readToken.role : [readToken.role]
      const user = readToken.preferred_username
      const userId = readToken.sub

      const Arr = {
        a: accessToken,
        r: refreshToken
      }
      localStorage.setItem('user', JSON.stringify(Arr))

      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`

      setAuth({ user, userId, role, accessToken, refreshToken })

      return accessToken
    } catch (error) {
      localStorage.removeItem('user')
      setAuth({})
      throw error
    }
  }

  return refresh
}

export default useRefreshToken
